import { FormattedMessage } from 'react-intl'
import HomeOnboardingDataWarehouse from './HomeOnboardingDataWarehouse'
import HomeOnboardingDataImport from './HomeOnboardingDataImport'
import HomeMaps from '../HomeMaps/HomeMaps'
import HomeDemoMaps from '../HomeMaps/HomeDemoMaps'
import HomeDemoWorkflows from '../HomeWorkflows/HomeDemoWorkflows'
import HomeWorkflows from '../HomeWorkflows/HomeWorkflows'
import { useDemoWorkflows } from 'features/workflows/hooks/query'
import { useAppSelector } from 'app/state'
import { getDemoMapsSorted } from 'features/maps/state/mapsSlice'
import { Grid } from '@mui/material'

export function HomeGettingStarted() {
  const { data: demoWorkflows } = useDemoWorkflows()
  const demoMaps = useAppSelector(getDemoMapsSorted)

  return (
    <>
      <HomeMaps
        mapsLength={demoMaps.length}
        title={<FormattedMessage id="home.onboarding.maps.title" />}
        emptyMapWithButton={true}
        isOnboarding
      >
        <HomeDemoMaps maps={demoMaps} />
      </HomeMaps>
      <HomeWorkflows
        workflowsLength={demoWorkflows?.length ?? 0}
        title={<FormattedMessage id="home.onboarding.workflows.title" />}
        emptyWorkflowWithButton={true}
        isOnboarding
      >
        <HomeDemoWorkflows workflows={demoWorkflows} />
      </HomeWorkflows>

      <Grid container spacing={3} my={5}>
        <Grid item sm={8}>
          <HomeOnboardingDataWarehouse />
        </Grid>
        <Grid item sm={4}>
          <HomeOnboardingDataImport />
        </Grid>
      </Grid>
    </>
  )
}

export default HomeGettingStarted
